"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
function assembleMissingArgsString(argumentNames) {
    const argumentNamesCopy = argumentNames ? [...argumentNames] : [];
    let argumentString;
    if (argumentNamesCopy.length <= 1) {
        argumentString = argumentNamesCopy[0];
    }
    else {
        const lastArgument = argumentNamesCopy.pop();
        argumentString = `${argumentNamesCopy.join(', ')} and ${lastArgument}`;
    }
    return argumentString;
}
/**
 * Thrown when an argument is missing
 * @param {Array<string>} argumentNames
 * @param {string} explanation
 */
class MissingArgumentsError extends ExtendableError_1.default {
    constructor(argumentNames, explanation = '') {
        super(`Missing ${assembleMissingArgsString(argumentNames)} arguments. ${explanation || ''}`);
        this.argumentNames = argumentNames;
        this.explanation = explanation;
    }
}
exports.default = MissingArgumentsError;
